module.exports = __webpack_public_path__ + "static/img/parking_equipment1_4.b483a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/parking_equipment1_4.jpg
// module id = IpAu
// module chunks = 0